
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import PlansSection from '../../components/feature/PlansSection';
import AboutSection from '../../components/feature/AboutSection';
import ContactSection from '../../components/feature/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <PlansSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
